import { maxBy } from 'lodash';
import * as React from 'react';
import { BaseRow, BaseRowFactory } from '../BaseRow';

export class AdvancedRulerRow extends BaseRow<AdvancedRulerRowFactory> {
  renderData() {
    const items: { pos: number, color: string }[] = []
    for (let i = 1; i < 80 / 10; i++) items.push({ pos: i * 10, color: "rgba(0,0,0,?)" });
    for (let i = 0; i <= 80 / 16; i++) items.push({ pos: i * 16, color: "rgba(0,0,255,?)" });

    const maxPos = maxBy(items, "pos")!.pos;
    return <div style={{
      position: "relative",
      width: `${maxPos + String(maxPos).length / 2}ch`,
    }} className="user-select-none">
      <span style={{ color: "transparent" }}>Ruler</span>
      {items.map((item, index) => {
        return <span key={index} style={{
          left: `${item.pos}ch`,
          position: "absolute",
          top: 0,
          display: "block",
          transform: "translateX(-50%)",
        }}>
          <span style={{
            backgroundColor: "white",
            borderWidth: "1px",
            borderStyle: "solid",
            borderColor: item.color.replace("?", "0.5"),
            color: item.color.replace("?", "1"),
            padding: "1px",
            fontSize: "60%",
            verticalAlign: "top"
          }}>{String(item.pos)}</span>
        </span>
      })}
    </div>
  }
}

export class AdvancedRulerRowFactory extends BaseRowFactory<typeof AdvancedRulerRow, {}, {}, {}> {
  generate(input: this['TInput']) {
    return {}
  }

  component = AdvancedRulerRow
}
